import { UpdateDealPortFormInput } from 'api/graphql';
import axios from 'axios';
import { dealPortModel, shareableLinkModel, ShareableLinkStatus } from 'model';
import { apiBaseUrl } from 'shared/links';

const useShareableLink = () => {
  const baseUrl = `${apiBaseUrl}/api/shareablelink`;

  const getShareableLinkStatus = async (linkId: string): Promise<ShareableLinkStatus> => {
    try {
      await axios.get(`${baseUrl}/status/${linkId}`);
      return 'ACTIVE';
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        switch (error.response.status) {
          case 410:
            return 'CLOSED';
          case 408:
            return 'EXPIRED';
          case 404:
            return 'NOT_FOUND';
          default:
            'UNKNOWN';
        }
      }
      return 'UNKNOWN';
    }
  };

  const getShareableLink = (linkId: string) =>
    axios.get<shareableLinkModel>(`${baseUrl}/dealport`, {
      params: {
        linkId
      }
    });

  const updateDealPortForm = (linkId: string, input: UpdateDealPortFormInput) =>
    axios.post<dealPortModel>(`${baseUrl}/dealport`, input, {
      params: {
        linkId
      }
    });

  const sendDealPortEmail = (linkId: string) =>
    axios.post(`${baseUrl}/dealport/email`, null, {
      params: {
        linkId
      }
    });

  return {
    getShareableLink,
    updateDealPortForm,
    sendDealPortEmail,
    getShareableLinkStatus
  };
};

export default useShareableLink;
